import { COLORS, fontFamilyFor } from "../../theme";

// Mirrors new-design/o7events-frontend's <nav> CSS 1:1 (nav / .nav-left /
// .logo / .logo-icon / .nav-right / .btn-create / .btn-login).
export const Style = {
  // Height = padding (matches new-design's `padding: 1.5rem 3rem`) + the
  // logo, the tallest item in the bar — NOT an extra explicit minHeight on
  // top of that padding, which was double-counting and making the bar
  // noticeably taller than new-design's real ~108px/~76px.
  main: (isHome, isEmployee) => ({
    width: "100%",
    height: { xs: "76px", md: "108px" },
    display: !isEmployee
      ? { xs: isHome ? "block" : "none", md: "block" }
      : "none",
  }),
  appBar: {
    background: "rgba(26,26,26,0.95)",
    backdropFilter: "blur(16px)",
    boxShadow: "none",
    borderBottom: "1px solid rgba(255,255,255,0.05)",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    py: { xs: "16px", md: "24px" },
    px: { xs: "16px", md: "48px" },
    minHeight: "0 !important",
  },
  menuButton: { mr: { xs: 0.5, md: 1.5 } },
  menuIcon: { height: "28px", width: "28px" },
  logoContainer: (isArabic) => ({
    cursor: "pointer",
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    gap: "0.8rem",
  }),
  logoImg: {
    height: { xs: "44px", md: "60px" },
    width: { xs: "44px", md: "60px" },
    objectFit: "contain",
  },
  optionsContainer: (isArabic) => ({
    display: "flex",
    gap: "16px",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
  }),
  langName: (isArabic) => ({
    cursor: "pointer",
    width: "46px",
    height: "46px",
    borderRadius: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: COLORS.gray,
    color: COLORS.white,
    overflow: "hidden",
  }),
  avatar: {
    width: "46px",
    height: "46px",
    padding: "7px",
    boxSizing: "border-box",
    background: COLORS.peach,
    color: COLORS.dark,
  },
  loginButtonSmall: (isArabic) => ({
    height: "auto",
    py: "12px",
    px: { xs: "18px", md: "32px" },
    borderRadius: "50px",
    background: COLORS.peach,
    color: COLORS.dark,
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: { xs: "13px", md: "15px" },
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    whiteSpace: "nowrap",
    "&:hover": { background: COLORS.gold },
  }),
  loginButton: (isArabic) => ({
    height: "auto",
    py: "12px",
    px: { xs: "18px", md: "32px" },
    borderRadius: "50px",
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.2)",
    color: COLORS.white,
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: { xs: "13px", md: "15px" },
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
    whiteSpace: "nowrap",
    "&:hover": { borderColor: COLORS.peach, color: COLORS.peach },
  }),
};
